import { observable, action, computed } from 'mobx';
import axios from '../lib/axios';

class ProductStore {
  @observable sections = [];
  @observable selectedProduct;
  @observable selectedProductContent;
  @observable selectedSection;

  @action loadProduct(id) {
    this.selectedProduct = null;
    this.selectedSection = null;
    axios.get(`/products/${id}`)
      .then((result) => {
        this.selectedProduct = result.data;
        this.selectedSection = this.sections.find(section => section.id === this.selectedProduct.section_id);
      })
      .catch((error) => {

      });
  }

  @action loadProductContent(id) {
    this.selectedProductContent = this.selectedProduct.product_contents.find(content => content.category.id === parseInt(id));
  }

  @action setSectionId(sectionId) {
    this.selectedSection = this.sections.find(section => section.id == sectionId);
  }

  @action setSection(section) {
    this.selectedSection = section;
  }

  @action fetchData() {
    axios.get('/sections')
      .then((result) => {
        this.sections = result.data;
      })
      .catch((error) => {

      });
  }

  @computed get relatedProducts() {
    return this.selectedSection.products.filter(product => product.id != this.selectedProduct.id);
  }

  @computed get sectionsIsLoaded() {
    return this.sections.length > 0;
  }
}

export default new ProductStore();



// WEBPACK FOOTER //
// ./src/stores/ProductStore.js